<template>
  <h1>Factsheets</h1>
</template>

<script>
export default {
  name: 'Factsheets',
  mounted() {
    console.log(this.$route)
  }
}
</script>

<style>

</style>